import React from "react";
import Button from "react-bootstrap/Button";
import "./error.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobile } from "@fortawesome/free-solid-svg-icons";

const ErrorPage = () => {
  return (
    <div className="error-wrapper">
      <div className="error-card">
        <img
          src="/img/error.png"
          alt="صفحه دچار مشکل شده است، دوباره تلاش کنید."
          width={300}
        />
        <p className="error-text">
          مشکلی پیش آمده است. نگران نباشید. می‌توانید دوباره امتحان کنید، و یا
          با پشتیبانی تماس بگیرید.
        </p>
        <p className="mb-0">
          <a href="#" className="text-dark">
            <FontAwesomeIcon icon={faMobile} fixedWidth /> 0253-3550487
          </a>
        </p>
        <p className="light-gray">
          در کانال{" "}
          <a
            href="https://eitaa.com/joinchat/2880832496C155a6954d3"
            className="text-primary-custom"
            target="_blank"
          >
            پشتیبانی
          </a>{" "}
          وقف نما در ایتا عضو شوید.
        </p>

        <Button
          variant="light"
          className="error-btn"
          onClick={() => window.location.reload()}
        >
          تلاش مجدد
        </Button>
      </div>

      <div className="error-bg-shape shape1"></div>
      <div className="error-bg-shape shape2"></div>
      <div className="error-bg-shape shape3"></div>
    </div>
  );
};

export default ErrorPage;
